export default __webpack_public_path__ + "static/media/airdome-half-dead.ac1c0434.svg";